import * as React from 'react'
import { IPeerGroupsProps, getPeerGroupData, IFilter, round, roundNumber, IVisualizationState, IPeerGroupTabsProps } from '../../lib/http';
import { Panel } from 'react-bootstrap';
import * as ReactHighcharts from 'react-highcharts'
import PanelGraph from 'app/components/tabs/PanelGraph';
const HighchartsMore = require('highcharts/highcharts-more')
HighchartsMore(ReactHighcharts.Highcharts)

export class ExpenseComparison extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    loading: false,
    title: '',
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: 0 }
  }

  componentDidMount() {
    this.setState({ data: this.props.data }, () => this.loadSeries(this.props.filters))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state
    const { currentPeerGroup } = this.props

    data.reverse()

    const filteredOutNationalGroup = data.filter((dataPoint) => dataPoint.filterId > 0)

    const seriesOne = filteredOutNationalGroup.map(dataPoint => [roundNumber(dataPoint.InvExp_N_V3_InvExp10thPct, 1), roundNumber(dataPoint.InvExp_N_V3_InvExp25thPct, 1)])
    const seriesTwo = filteredOutNationalGroup.map(dataPoint => [roundNumber(dataPoint.InvExp_N_V3_InvExp25thPct, 1), roundNumber(dataPoint.InvExp_N_V1_InvExpMdn, 1)])
    const seriesThree = filteredOutNationalGroup.map(dataPoint => [roundNumber(dataPoint.InvExp_N_V1_InvExpMdn, 1), roundNumber(dataPoint.InvExp_N_V3_InvExp75thPct, 1)])
    const seriesFour = filteredOutNationalGroup.map(dataPoint => [roundNumber(dataPoint.InvExp_N_V3_InvExp75thPct, 1), roundNumber(dataPoint.InvExp_N_V3_InvExp90thPct, 1)])
    const categories = filteredOutNationalGroup.map(dataPoint => dataPoint.InvExp_T_V3_ColName)
    const title = currentPeerGroup ? currentPeerGroup.InvExp_T_V3_Vis3Title : ''


    const series = [
      { color: '#DDEBF7', name: 'Expense Range', data: seriesOne, marker: { symbol: 'circle' } },
      { color: '#C8DDF0', name: 'Expense Range', data: seriesTwo, marker: { symbol: 'circle' } },
      { color: '#BDD7EE', name: 'Expense Range', data: seriesThree, marker: { symbol: 'circle' } },
      { color: '#B3D0EB', name: 'Expense Range', data: seriesFour, marker: { symbol: 'circle' } },
    ]

    this.setState({ title, categories, series, loading: false })
  }

  static getChartConfig(series, categories, title) {
    return {
      chart: { type: 'arearange' },
      title: {
        text: title,
      },
      subtitle: {
        text: 'In basis points',
        style: {
          "font-size": "15px"
        }
      },
      yAxis: { visible: false },
      xAxis: { type: 'category', categories },
      legend: {
        enabled: false
      },
      plotOptions: {
        arearange: {
          dataLabels: {
            enabled: true,
            verticalAlign: 'bottom',
          }
        }
      },
      credits: {
        enabled: false
      },
      series,
    }
  }

  render() {
    const { loading, title, series, categories } = this.state
    return (
      <PanelGraph loading={loading} title="" chartConfig={ExpenseComparison.getChartConfig(series, categories, title)} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Expenses/ExpenseComparison/index.tsx